export const conciliationTypeOptions = [
  { value: "GravityConciliation", label: "Gravity" },
  { value: "OtherConciliation", label: "Other" },
  { value: "Settlement", label: "Receivables" },
  { value: "Payeesettlement", label: "Payables" },
  { value: "Chartofaccount", label: "Chart of Account" },
];

export function conciliationLabel(item) {
  if (!item?.conciliation_type) return null;
  const target = item.conciliation || {};

  switch (item.conciliation_type) {
    case "GravityConciliation":
      return `Gravity batch #${target.batch_number || target.id || ""}`.trim();

    case "OtherConciliation": {
      const suffix = target.memo || target.type || "";
      return suffix ? `Other batch - ${suffix}` : "Other batch";
    }

    case "Settlement": {
      const student = target.receivable?.issuer?.student || target.student;
      const name = student
        ? `${student.name || ""} ${student.last_name || ""}`.trim()
        : target.name || "";
      const invoice =
        target.invoice_number || target.receivable?.invoice_number || "";
      return [name, invoice].filter(Boolean).join(" - ") || "Settlement";
    }

    case "Payeesettlement": {
      const merchant =
        target.payee?.issuer?.merchant?.name || target.merchant?.name || "";
      const invoice = target.invoice_number || target.payee?.invoice_number || "";
      return [merchant, invoice].filter(Boolean).join(" - ") || "Payee";
    }

    case "Chartofaccount":
      return (
        [target.code, target.name].filter(Boolean).join(" ") ||
        "Chart of Account"
      );

    default:
      return item.conciliation_type;
  }
}
